module.exports = __webpack_public_path__ + "static/media/YM32_0.6fef5f09.jpg";